import { Provider } from "react-redux";
import InputForm from "./components/InputForm";
import PreviewData from "./components/PreviewData";
import store from "./redux/store";


export default function App() {
  return (
    <Provider store={store}>
      <body>
        <header id="header">
          <div className="container">
            <img src="/images/lws-logo.svg" alt="logo" className="logo" />
            <div className="flex items-center">
              <a className="text-white min-w-[50px] font-medium" href="#">Home</a>
              <button className="log-btn btn">Login</button>
            </div>
          </div>
        </header>
        <section>
          <InputForm />
          <PreviewData />
        </section>
      </body>
    </Provider>
  );
}
